/**
 * Created by Marcus Zhao on 12/1/2020
 * Description:
 * ---------maintenance history-------------
 * Updated by Daniel Wang on 12/30/2022, To implement the contact template draggable.
 */
import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import * as _lodash from 'lodash';

import { ContextMenuConfig, ContextMenuShowAction } from '../../../widgets/tam-context-menu/tam-context-menu.model';
import { TemplateSettingDialogService } from '../template-setting-dialog.service';
import { SettingConfig, ActionType, FieldControl, contactDefField, FieldType, DefaultContextMenu } from '../template-setting-dialog.model';
import { ContactDialogSectionName } from '../../contact-detail-new/contact-body-detail.model';

@Component({
    selector: 'tam-template-setting-fields',
    templateUrl: './template-setting-fields.component.html',
    styleUrls: ['./template-setting-fields.component.scss']
})
export class TemplateSettingFieldsComponent implements OnInit, OnDestroy {
    @Input() config;
    contextMenuConfig: ContextMenuConfig;
    fieldArray = new Array<FieldControl>();
    birthBtnDisabled = false;
    genderBtnDisabled = false;
    middleNameBtnDisabled = false;
    prefixBtnDisabled = false;
    suffixBtnDisabled = false;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _templateSettingService: TemplateSettingDialogService,
        private _changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit() {
        this._initFieldData();
        this._initContextMenu();
        this._initFieldStatus();
        this._destroySubscriptions.push(
            this._templateSettingService.actionSubject$.subscribe(item => this._settingTemplateField(item)));

    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroySubscriptions = [];
    }

    /**
     * set contextMenu
     *
     * @param {*} event
     * @param {*} item
     * @memberof TemplateSettingFieldsComponent
     */
    fieldContextMenu(event, item) {
        if (item.name === contactDefField.Birthday || item.name === contactDefField.Gender) {
            this._changeDetectorRef.detectChanges();
            this.contextMenuConfig.show$.next(new ContextMenuShowAction(event, item));
        } else {
            item.isDisable = true;
            this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.ADD, item, ContactDialogSectionName.BasicInformation));
        }
    }

    /**
     * menu click
     *
     * @param {*} res
     * @memberof TemplateSettingFieldsComponent
     */
    onFileMenuSelect(res) {
        res.payload.data.isDisable = true;
        this.birthBtnDisabled = true;
        const type = +res.payload.id;
        const data = res.payload.data;
        let secName = DefaultContextMenu.BASICINFOR;
        switch (type) {
            case 0:
                secName = DefaultContextMenu.BASICINFOR;
                break;
            case 1:
                secName = DefaultContextMenu.OTHER;
                break;
            default:
                break;
        }
        this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.ADD, data, secName));
    }

    private _initContextMenu() {
        this.contextMenuConfig = new ContextMenuConfig();
        this.contextMenuConfig.stateful = false;
        this.contextMenuConfig.items = [
            { id: '0', text: DefaultContextMenu.BASICINFOR, disabled: false },
            { id: '1', text: DefaultContextMenu.OTHER, disabled: false },
        ];
        this.contextMenuConfig.events$.subscribe(event => this.onFileMenuSelect(event));
    }

    /**
     * init field data
     *
     * @private
     * @memberof TemplateSettingFieldsComponent
     */
    private _initFieldData() {
        const birthdayField = new FieldControl(contactDefField.Birthday, FieldType.DATE, false);
        const genderField = new FieldControl(contactDefField.Gender, FieldType.singleDropdown, false);
        const middleNameField = new FieldControl(contactDefField.MiddleName, FieldType.INPUT, false);
        const preFixField = new FieldControl(contactDefField.Prefix, FieldType.singleDropdown, false);
        const suffixField = new FieldControl(contactDefField.Suffix, FieldType.singleDropdown, false);
        this.fieldArray.push(birthdayField, genderField, middleNameField, preFixField, suffixField);
    }

    /**
     * set fields  status
     * @private
     * @memberof TemplateSettingFieldsComponent
     */
    private _initFieldStatus() {
        if (this.config) {
            this.config.forEach(section => {
                section.container.forEach(layout => {
                    layout.forEach(item => {
                        this.fieldArray.findIndex(ctrl => {
                            if (ctrl.name === item.config.controlName) {
                                ctrl.isDisable = true;
                            }
                        });
                    });
                });
            });
        }
    }

    /**
     * set field status
     *
     * @private
     * @param {SettingConfig} field
     * @memberof TemplateSettingFieldsComponent
     */
    private _settingTemplateField(field: SettingConfig) {
        if (field.action === ActionType.DELETE) {
            this.fieldArray.forEach(item => {
                if (item.name === field.data.name) {
                    item.isDisable = false;
                }
            });
        } else if (field.action === ActionType.RESET) {
            this.fieldArray.forEach(item => {
                if (item.name === contactDefField.Birthday) {
                    item.isDisable = true;
                } else {
                    item.isDisable = false;
                }
            });
        }
    }
}
